import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import PageBreadcrumb from "@/components/PageBreadcrumb";
import Footer from "@/components/Footer";
import ContactHero from "@/components/ContactHero";
import ContactForm from "@/components/ContactForm";
import ContactInfo from "@/components/ContactInfo";

const Contact = () => {
  return (
    <>
      <Helmet>
        <title>Contact Us | AI-labbet</title>
        <meta name="description" content="Get in touch with AI-labbet. Contact us to discuss your AI strategy, governance needs, or training programs." />
      </Helmet>
      
      <div className="min-h-screen flex flex-col">
        <Header />
        <PageBreadcrumb currentPage="Contact" />
        <main className="flex-grow pt-20">
          <ContactHero />
          
          <section className="py-20 md:py-24">
            <div className="container mx-auto px-6">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                <ContactForm />
                <ContactInfo />
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Contact;
